// Utility function to check if user can delete on a specific page
// Returns true if:
// 1. User is Admin, OR
// 2. User has 'full' access level for the current page path

export function canUserDelete(user, pagePath) {
  if (!user) return false;
  if (user.role === 'Auditor') return false;
  
  // Admin always has delete access
  if (user.role === 'Admin') return true;
  
  // Check page-specific access level
  const pageAccess = user.page_access || {};
  const accessLevel = pageAccess[pagePath];
  
  // 'full' means Edit & Delete access
  return accessLevel === 'full';
}

// Utility function to check if user can edit on a specific page
// Returns true if:
// 1. User is Admin, OR
// 2. User has 'edit' or 'full' access level for the current page path
export function canUserEdit(user, pagePath) {
  if (!user) return false;
  if (user.role === 'Auditor') return false;
  
  // Admin always has edit access
  if (user.role === 'Admin') return true;
  
  // Check page-specific access level
  const pageAccess = user.page_access || {};
  const accessLevel = pageAccess[pagePath];
  
  // 'edit' = View & Edit, 'full' = Edit & Delete — both allow editing
  return accessLevel === 'edit' || accessLevel === 'full';
}

// Get current page path from window location
export function getCurrentPagePath() {
  const path = window.location.pathname;
  // Remove trailing slash if present
  return path.endsWith('/') && path.length > 1 ? path.slice(0, -1) : path;
}

// Combined helper - check if user can delete on current page
export function useCanDelete(user) {
  const pagePath = getCurrentPagePath();
  return canUserDelete(user, pagePath);
}
